'use es6';

export default {
  ACTIVE: 'ACTIVE',
  ON_HOLD: 'ON_HOLD',
  CLOSED: 'CLOSED',
  UNKNOWN: 'UNKNOWN'
};